module.exports = __webpack_public_path__ + "static/media/banner_loja.aa50b127.png";